import { supabase } from "../lib/supabase";

export async function checkCityIsLive(city) {
  if (!city) return false;

  const { data, error } = await supabase
    .from("city_launch_controls")
    .select("is_live")
    .ilike("city_name", city)
    .maybeSingle();

  if (error) throw error;
  return !!data?.is_live;
}
